import React from "react";
import ConfirmModal from "./ConfirmModal";
import {removeRelationshipChild} from "../reducer";
import {eventRelationshipChildRemoved} from "../../../components/eventBus/reducer";
import {useDispatch} from "react-redux";

const ChildUnlinkButton = ({childId}: any) => {

    const dispatch = useDispatch();

    const onSave = () => {
        removeRelationshipChild(childId).then(() => {
            dispatch(eventRelationshipChildRemoved());
        });
    };

    return (
        <ConfirmModal onSave={onSave} title="Kind entfernen?">
            <div className="unlink-button">
                <i className="fa fa-unlink"/>
            </div>
        </ConfirmModal>
    );
};


export default ChildUnlinkButton;
